import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/armarLogo-2.png'; 

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  const handleLinkClick = () => {
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Useful Information', path: '/useful-information' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <>
  
      <nav className={`fixed top-0 w-full z-[100] bg-[#fdfcfb] transition-all duration-500 ${isMenuOpen ? 'shadow-none' : 'shadow-sm'} py-4 md:py-2 border-b border-[#0a111f]/5`}>
        <div className="max-w-7xl mx-auto px-8 md:px-12 flex items-center justify-between">
          
      
          <Link to="/" onClick={handleLinkClick} className="relative z-[110]">
            <img
              src={logo}
              alt="Armar Shipping"
              className={`transition-all duration-500 ${isMenuOpen ? 'h-12' : 'h-14 md:h-20'} w-auto object-contain`}
            />
          </Link>


          <div className="hidden lg:flex items-center space-x-12">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={handleLinkClick}
                className={`relative text-[15px] font-bold uppercase tracking-[0.25em] transition-all duration-300 ${
                  location.pathname === link.path ? 'text-[#c4a47c]' : 'text-[#0a111f]/80 hover:text-[#c4a47c]'
                }`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-[1.5px] bg-[#c4a47c] transition-all duration-500 ${
                  location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'
                }`}></span>
              </Link>
            ))}
          </div>

          {/* Mobile Toggle Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden relative z-[110] p-2 focus:outline-none"
          >
            <div className="w-8 h-5 relative flex flex-col justify-between items-end">
              <span className={`h-[1.5px] bg-[#0a111f] transition-all duration-500 transform ${isMenuOpen ? 'w-8 -rotate-45 translate-y-[9.5px]' : 'w-8'}`}></span>
              <span className={`h-[1.5px] bg-[#c4a47c] transition-all duration-300 ${isMenuOpen ? 'opacity-0 scale-0' : 'w-5'}`}></span>
              <span className={`h-[1.5px] bg-[#0a111f] transition-all duration-500 transform ${isMenuOpen ? 'w-8 rotate-45 -translate-y-[9.5px]' : 'w-3'}`}></span>
            </div>
          </button>
        </div>
      </nav>

 
      <div className={`fixed inset-0 z-[90] transition-all duration-[850ms] ease-[cubic-bezier(0.8,0,0.2,1)] ${
        isMenuOpen ? 'translate-y-0' : '-translate-y-full'
      }`}>
        <div className="absolute inset-0 bg-[#fcfcf9]"></div>
        
   
        <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none select-none">
          <img src={logo} alt="" className="w-4/5 grayscale rotate-12 scale-150" />
        </div>

        <div className="relative h-full flex flex-col items-center justify-center space-y-12 px-10 pt-20">
          {navLinks.map((link, index) => (
            <Link
              key={link.name}
              to={link.path}
              onClick={handleLinkClick}
              className={`group relative text-[14px] font-medium uppercase tracking-[0.6em] transition-all duration-700 ${
                location.pathname === link.path ? 'text-[#c4a47c]' : 'text-[#0a111f]'
              } ${isMenuOpen ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              {link.name}
              <span className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-0 h-[1px] bg-[#c4a47c] transition-all duration-500 group-hover:w-full"></span>
            </Link>
          ))}

  
          <div className={`absolute bottom-16 left-0 w-full text-center transition-all duration-1000 delay-500 ${isMenuOpen ? 'opacity-25 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="w-10 h-[1px] bg-[#0a111f] mx-auto mb-6"></div>
           
          </div>
        </div>
      </div>


      <div className="h-[70px] lg:h-[30px] bg-[#fcfcf9]"></div>
    </>
  );
};

export default Navbar;